export function getRandomProductId() {
  const idLength = 10;
  const min = Math.pow(10, idLength - 1);
  const max = Math.pow(10, idLength) - 1;
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  return randomNumber;
}
